import { createFileRoute, redirect } from '@tanstack/react-router';

import { RemindersPage } from '@/features/reminders/RemindersPage';
import { useAuthStore } from '@/shared/stores/authStore';

export const Route = createFileRoute('/admin/reminders')({
  beforeLoad: () => {
    // Reminders need `manage_reminders` (REVIEWER / MODERATOR / SUPER_ADMIN).
    // VIEWERs can't use it — the API 403s, so keep them out of the route too.
    const role = useAuthStore.getState().user?.adminRole;
    if (role === 'VIEWER') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router contract: beforeLoad throws a redirect object.
      throw redirect({ to: '/admin' });
    }
  },
  component: RemindersPage,
});
